import { render, staticRenderFns } from "./BuildManagement.vue?vue&type=template&id=156a92c0&scoped=true&"
import script from "./BuildManagement.vue?vue&type=script&lang=ts&"
export * from "./BuildManagement.vue?vue&type=script&lang=ts&"
import style0 from "./BuildManagement.vue?vue&type=style&index=0&id=156a92c0&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "156a92c0",
  null
  
)

export default component.exports